export default "__VITE_ASSET__Bx2Q5AfH__"